import {RoomClientState} from '../../../../shared/scripts/RoomClientState.ts'
import {TranslationObject} from '@colonist/i18n'
import {RoomTab, UIMFullscreenTabView} from './UIMFullscreenTabView'
import {UIMRoomModeController} from './UIMRoomModeController'
import {UIMRoomMapController} from './UIMRoomMapController'
import {uiManager} from '../../EntryMobile'
import {RoomStep} from './UIMCreateRoomController'
import {UIMSceneEnum} from '../../../../../shared/enums/UIMSceneEnums'
import {createDiv} from '../../../../shared/scripts/ui_utils/DomUtils'
import {ViewPopupBecomeMemberGameplay} from '../../../../shared/scripts/ui_popup/ViewPopupBecomeMemberGameplay'

enum EditPageTabs {
    SelectMode,
    SelectMap,
}
export class UIMRoomEditPageController {
    protected roomState: RoomClientState
    protected roomPageView: UIMFullscreenTabView

    private roomModeController: UIMRoomModeController
    private roomMapController: UIMRoomMapController

    constructor(roomState: RoomClientState) {
        this.roomState = roomState
        this.initializeRoomPageView()
        this.createAdElement()
        void this.initializeControllers()
    }

    protected initializeRoomPageView() {
        const title: TranslationObject = {key: 'strings:roomPage.notifications.edit'}
        const tabProperties: RoomTab[] = [
            {
                title: {key: 'strings:game.settings.gameInfoTab.gameMode.titleAbbreviated'},
                isActive: true,
                containerClass: 'm-room-settings-cards-container-grid',
                id: EditPageTabs.SelectMode,
            },
            {
                title: {key: 'strings:game.settings.gameInfoTab.map.title'},
                isActive: false,
                containerClass: 'm-room-settings-cards-container-grid',
                id: EditPageTabs.SelectMap,
            },
        ]
        const buttonText: TranslationObject = {key: 'strings:roomPage.save'}
        this.roomPageView = new UIMFullscreenTabView(title, tabProperties, buttonText)
    }

    protected async initializeControllers() {
        this.roomModeController = new UIMRoomModeController(this.roomPageView.getContainerWithTabIdx(EditPageTabs.SelectMode), this.roomState)
        this.roomMapController = new UIMRoomMapController(this.roomPageView.getContainerWithTabIdx(EditPageTabs.SelectMap), this.roomState)
        this.roomPageView.setOnClickContinueButton((isLastStep) => this.goToPageView(isLastStep))
    }

    private createAdElement() {
        const adContainer = createDiv('banner_private_ad')
        this.roomPageView.body.prepend(adContainer)
        uiManager.adController.showLobbyVerticalAds()
    }

    update(roomState: RoomClientState) {
        this.roomState = roomState
        this.roomModeController.update(roomState)
        this.roomMapController.update(roomState)
    }

    showView(tabIndex?: number) {
        this.roomPageView.show()
        if(tabIndex != undefined) this.roomPageView.updateActiveTabToIndex(tabIndex)
    }

    hideView() {
        this.roomPageView.hide()
    }

    exitView() {
        this.roomPageView.updateActiveTabToIndex(EditPageTabs.SelectMode)
        this.roomPageView.hide()
    }

    private goToPageView(isLastStep: boolean) {
        if(!isLastStep) return
        const isMapAccessible = this.roomMapController.isSelectedMapAccessible
        const isModeAccessible = this.roomModeController.isSelectedModeAccessible
        if(isMapAccessible && isModeAccessible) {
            return this.showRoomPage()
        }

        const checkAction = () => {
            uiManager.sceneController.loadScene(UIMSceneEnum.Store)
        }
        const xAction = () => {
            const tabToShow = isModeAccessible ? EditPageTabs.SelectMap : EditPageTabs.SelectMode
            this.roomPageView.updateActiveTabToIndex(tabToShow)
        }
        new ViewPopupBecomeMemberGameplay(checkAction, undefined, xAction, true)
    }

    // eslint-disable-next-line class-methods-use-this
    protected showRoomPage() {
        uiManager.createRoomController.setShowPageOnNextUpdate(RoomStep.RoomPage, true)
    }
}
